import { setSpecificMessage, creditCard } from "valibot";
setSpecificMessage(
  creditCard,
  (issue) => `Carte de crédit invalide: reçu ${issue.received}`,
  "fr"
);